import classname from 'classnames';
import { isString } from 'lodash';
import { bool, func, node, number, oneOf, oneOfType, string } from 'prop-types';
import React from 'react';
import { Text } from '@chaser/components';
import style from './ChaserSelect.module.scss';

const ChaserSelect = ({
  children,
  onChange = () => {},
  value = '',
  className = '',
  error = undefined,
  height = 'medium',
  disabled = false,
  ...rest
}) => (
  <div
    className={classname(style.selectWrapper, disabled && style.disabled, style[height], className)}
  >
    <select
      {...rest}
      disabled={disabled}
      className={classname(style.select, error && style.error)}
      value={value}
      onChange={onChange}
    >
      {children}
    </select>
    {isString(error) && (
      <Text className={style.errorLabel} fontSize="xsmall" color="Red">
        {error}
      </Text>
    )}
  </div>
);

export default ChaserSelect;

ChaserSelect.propTypes = {
  children: node.isRequired,
  onChange: func,
  value: oneOfType([string, number]),
  className: oneOfType([string, number]),
  error: oneOfType([bool, string]),
  height: oneOf(['small', 'medium']),
  disabled: bool,
};
